import React from 'react';
import classes from './Graph.module.css';
import styles from './Graph.module.css';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, } from 'recharts';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, } from 'recharts';
import filter from '../../../../Assets/funnel.png'; // For the filter icon


const data = [
    { metrics: '0', revenue: 0, expenses: 0 },
    { metrics: '0.25', revenue: 0, expenses: 0 },
    { metrics: '0.5', revenue: 0, expenses: 0 },
    { metrics: '0.75', revenue: 0, expenses: 0 },
    { metrics: '1', revenue: 0, expenses: 0 },
    // { month: 'Jun', revenue: 4700000, expenses: 2800000 },
];



const datas = [
    { name: 'Inventory', value: 4000000 },
    { name: 'Salaries', value: 3000000 },
    { name: 'Rent', value: 2000000 },
    { name: 'Utilities', value: 1500000 },
    { name: 'Marketing', value: 1000000 },
];


const expenseColors = {
    Inventory: '#22C55E',     // Green
    Salaries: '#3B82F6',      // Blue
    Rent: '#F59E0B',          // Orange
    Utilities: '#EF4444',     // Red
    Marketing: '#A78BFA',     // Purple
};

// Color palette matching the image
const COLORS = ['#22C55E', '#3B82F6', '#F59E0B', '#EF4444', '#A78BFA'];

// Custom horizontal legend
const renderLegend = () => (
    <ul style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '15px',
        fontSize: '10px',
        fontFamily: 'Sora',
        fontWeight: 400,
        marginTop: '16px',
        listStyle: 'none',
        bottom: 40,
        position: 'absolute',
        maxWidth: '80%',
    }}>
        {datas.map((entry, index) => (
            <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', color: '#374151', fontWeight: 500 }}>
                <span style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: expenseColors[entry.name],
                    display: 'inline-block'
                }} />
                <span>{entry.name}</span>
            </li>
        ))}
    </ul>
);

// const renderLegend = (props) => {
//     const { payload } = props;
//     return (
//         <ul className="flex justify-center flex-wrap gap-x-6 gap-y-2 mt-4 text-sm font-medium text-gray-700">
//             {payload.map((entry, index) => (
//                 <li key={`item-${index}`} className="flex items-center space-x-2">
//                     <span
//                         className="inline-block w-3 h-3 rounded-full"
//                         style={{ backgroundColor: entry.color }}
//                     />
//                     <span>{entry.value}</span>
//                 </li>
//             ))}
//         </ul>
//     );
// };



export default function Graphs() {

    return (
        <div className={classes.graphContainer}>

            {/* graph 1 begins here */}

            {/* <div className={`"bg-white shadow-lg rounded-xl p-6 max-w-4xl mx-auto" ${classes.graphContain}`}> */}
            {/* Header */}
            {/* <div className={`"flex justify-between items-start mb-4" ${classes.flex}`}>
                    <div>
                        <h2 className={`"text-xl font-bold text-gray-900"  ${classes.rvntxt}`}>Profit & Loss</h2>
                        <p className={`"text-sm text-gray-500"  ${classes.rvntxtsml}`}>Current month breakdown</p>
                    </div>
                    <button className={`"text-gray-600 hover:text-black" ${classes.filter}`}>
                        <img src={filter} className={classes.filter} />
                    </button>
                </div> */}

            {/* Chart */}
            {/* <div style={{ width: '100%', height: 300 }}>
                    <ResponsiveContainer>
                        <LineChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={true} />
                            <XAxis dataKey="metrics" tick={{ fill: '#667085', fontSize: 14 }} />
                            <YAxis
                                type="number"
                                domain={[0, 3]}
                                tickFormatter={(value) => {
                                    const labels = [
                                        'Net profit',
                                        'Operating Expenses',
                                        'Cost of goods',
                                        'Revenue',
                                    ];
                                    return labels[value] || '';
                                }}
                                tick={{ fill: '#667085', fontSize: 14 }}
                            />
                            <Tooltip formatter={(value) => `₦${value.toLocaleString()}`} />
                            <Line
                                type="monotone"
                                dataKey="revenue"
                                stroke="#6EDF98"
                                strokeWidth={3}
                                // dot={{ fill: '#16A34A', r: 5 }}
                                strokeOpacity={0.7}
                            />
                            <Line
                                type="monotone"
                                dataKey="expenses"
                                stroke="#FFD4D4"
                                strokeWidth={3}
                                // dot={{ fill: '#EF4444', r: 5 }}
                                strokeOpacity={0.7}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div> */}
            {/* </div> */}



            <div className={styles.card}>
                <h2 className={styles.title}>Profit &amp; Loss</h2>
                <p className={styles.subtitle}>Current month breakdown</p>

                <div className={styles.chartWrapper}>
                    {/* Y-Axis Labels */}
                    <div className={styles.yAxis}>
                        <span>Net Profit</span>
                        <span>Operating Expenses</span>
                        <span>Cost of Goods</span>
                        <span>Revenue</span>
                    </div>

                    {/* Chart Grid */}
                    <div className={styles.gridContainer}>
                        {/* Horizontal dashed lines */}
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className={styles.gridRow}></div>
                        ))}

                        {/* Vertical grid lines */}
                        <div className={styles.verticalGridLines}>
                            {[...Array(5)].map((_, i) => (
                                <div key={i} className={styles.gridCol}></div>
                            ))}
                        </div>

                        {/* X-Axis Labels */}
                        <div className={styles.xAxis}>
                            {[0, 0.25, 0.5, 0.75, 1].map((val) => (
                                <span key={val} className={styles.xLabel}>
                                    {val}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* graph 1 ends here */}

            {/* graph 2 begins here */}

            <div className={`"bg-white rounded-xl p-6 max-w-md mx-auto" ${classes.graphContainpie}`}>
                {/* Header */}
                <div className="mb-4">
                    <h2 className={`"text-xl font-bold text-gray-900" ${classes.rvntxt}`}>Top Expenses</h2>
                    <p className={`"text-sm text-gray-500" ${classes.rvntxtsml}`}>By category</p>
                </div>

                {/* Donut Chart */}
                <div style={{ width: '300', height: 300 }}>
                    <ResponsiveContainer className={classes.piechartdk}>
                        <PieChart>
                            <Pie
                                data={datas}
                                cx="50%"
                                cy="35%"
                                innerRadius={40}
                                outerRadius={90}
                                paddingAngle={4}
                                dataKey="value"
                                stroke="none"
                            >
                                {datas.map((entry, index) => (
                                    <Cell key={`slice-${entry.name}`} fill={expenseColors[entry.name]} />
                                ))}
                            </Pie>
                            <Legend content={renderLegend} />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* graph 2 begins ends here */}
            {/* graph 3 begins here */}

            <div className={classes.graphContainKnt}>
                {/* Header */}
                <div >
                    <h2 className={classes.rvntxt}>Bank Accounts</h2>
                    <p className={classes.rvntxtsml}>Connected accounts</p>
                </div>

                {/* Transaction  */}
                <div className={classes.trstnal}>
                    <div className={classes.dotter} >
                        <div className={classes.dot} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>GTB Business Account</p>
                                <p className={classes.akantnum}>****6789</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                                <button className={classes.cnnectd}>connected</button>
                            </div>

                        </div>
                    </div>
                    <div className={`${classes.dotter} ${classes.topspc}`}>
                        <div className={classes.dot} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>Access Bank Current</p>
                                <p className={classes.akantnum}>****4321</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                                <button className={classes.cnnectd}>connected</button>
                            </div>

                        </div>
                    </div>
                    <div className={`${classes.dotter} ${classes.topspc}`} >
                        <div className={classes.dott} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>Zenith Bank Savings</p>
                                <p className={classes.akantnum}>****4455</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                                <button className={classes.cnnected}>pending</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* graph 3 begins ends here */}
        </div>
    );
}